<template>
  <AnimatedButton icon="ecc:ecc-T-Help" @click="onClick"></AnimatedButton>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue';
import AnimatedButton from '../../components/UIComponents/AnimatedButton.vue';
import { store } from './Help.store'

const props = defineProps<{
  id: string;
}>();

const onClick = ($event) => {
  store.drawerItems[props.id].toggle($event)
};

onMounted(() => {
  store.add(props.id);
});

onUnmounted(() => {
  store.remove(props.id);
});
</script>